import { render, staticRenderFns } from "./RadioFilled.vue?vue&type=template&id=313de93c"
import script from "./RadioFilled.vue?vue&type=script&lang=ts"
export * from "./RadioFilled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports